import { render, staticRenderFns } from "./DetailBox.vue?vue&type=template&id=51639053&"
import script from "./DetailBox.vue?vue&type=script&lang=js&"
export * from "./DetailBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports